import React, { useReducer, useEffect } from 'react';
import PropTypes from 'prop-types';
import { joinClassNames } from '../../utils/library';
import { debounce } from '@Utils/debounce';
import { DEBOUNCE_PERIOD } from '../../utils/constants';
import './search.css';
import { connect } from 'react-redux';
import { setSearchText } from '../../redux/actions/common/common-action';
import { useToggleFeat } from '../../toggleFeature';
import styled from 'styled-components';
import CircularProgress from '@material-ui/core/CircularProgress';
import useDeviceWidth from '../../hooks/getDeviceWidth';
import Popup from 'semantic-ui-react/dist/commonjs/modules/Popup';
import {
  ACC_ICON,
  CLOSE,
  DROPDOWN_LIGHT_ICON,
  INFO_GREY_ICON,
  LOCATION_PIN_ICON,
  SEARCH_ICON,
  SEARCH_SMALL_ICON
} from '@Images';
import COLORS from '../../common/styles/color-pallete';
import DEVICES from '../../common/styles/devices';
import CommonButton from '../common-button/CommonButton';
import { FONT_FAMILY } from '../../common/styles/fontStyles';

const Container = styled.div`
  position: absolute;
  right: 10px;
  border: none !important;
  :hover {
    border: none !important;
  }
`;

const Link = styled.div`
  width: 34px;
  height: 19px;
  object-fit: contain;
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${COLORS.brandPrimary};
  text-decoration: underline;
  cursor: pointer;
`;
const Img = styled.img`
  margin-left: 20px;
  margin-bottom: 2px;
`;
const ImgRotate = styled.img`
  margin-left: 20px;
  margin-bottom: 2px;
  transform: rotate(90deg);
  cursor: pointer;
`;

const ManualAddressField = styled.div`
  margin-top: 16px;
`;

const MediaLink = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 6px;
  img {
    transform: ${(p) => (!p.showFields ? 'rotate(0deg)' : 'rotate(90deg)')};
  }
  @media only screen and (max-width: 1080px) {
    margin-left: -18%;
  }
  @media only screen and (min-width: 500px) and (max-width: 1024px) {
    margin-left: -19%;
  }
  @media only screen and (max-width: 499px) {
    margin-left: -42%;
  }
`;
export const AddressButtonLink = styled.div`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  margin-top: 2px;
  cursor: pointer;
  /* identical to box height */
  text-decoration-line: underline;
  color: ${COLORS.brandPrimary};
  margin-left: 10px;
`;
export const ButtonLink = styled.div`
  margin-top: 10px;
  height: 50px;
  border: ${(props) => (props.isSbmReferral ? `solid 2px #083A9B` : 'solid 2px #48F9FE')};
  width: fit-content;

  font-family: ${FONT_FAMILY.hellix.regular} !important;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  /* &:before {
    content:"\A";
    border-style: solid;
    border-width: 10px 15px 10px 0;
    border-color: transparent #dd4397 transparent transparent;
    position: absolute;
    left: -15px;
    } */
  cursor: pointer;
  width: 325px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  box-sizing: border-box;
  border-radius: ${(props) => (props.isSbmReferral ? '0px' : '4px')};
  letter-spacing: 1px;
  color: ${(props) => (props.isSbmReferral ? '#083A9B' : '#000000')};
`;

export const BorderedSearch = styled.div`
  width: ${(props) => (props.boxInputSearchNewUi ? '450px' : '325px')} !important;
  height: 50px;
  border-radius: 3px;
  border: solid 1px ${COLORS.textDarkGray};
  background-color: ${COLORS.white};
  display: flex;
  align-items: center;
  position: relative;

  .boxInputSearchIcon {
    width: 24px;
    height: 24px;
  }
  > input {
    color: #000000;
    width: 100%;
    border: none !important;
    height: 1.1875em;
    margin: 0;
    display: block;
    padding: 6px 0 7px;
    min-width: 0;
    background: none;
    box-sizing: content-box;
    align-self: center;
    margin-left: 10px;
    font-size: 1rem;
    box-sizing: border-box;
    align-items: center;
    font-family: ${FONT_FAMILY.hellix.regular};
    font-weight: 400;
    line-height: 1.1875em;
    letter-spacing: 0.00938em;
    min-height: 50px;
    ::placeholder {
      font-family: ${FONT_FAMILY.hellix.regular};
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-transform: none;
      color: #666e7c;
    }
  }
  :hover {
    border: 1px solid #000;
  }
  :focus-within {
    border: 1px solid #000;
  }
  @media only screen and (max-width: 1080px) {
    width: ${(props) => (props.boxInputSearchNewUi ? '450px' : '328px')} !important;
    margin: 0px;
  }
  @media ${DEVICES.mobileXL} {
    width: ${(props) => (props.boxInputSearchNewUi ? '400px' : '328px')} !important;
  }
  @media ${DEVICES.mobileL} {
    width: ${(props) => (props.boxInputSearchNewUi ? '350px' : '328px')} !important;
  }
  @media ${DEVICES.mobileM} {
    width: ${(props) => (props.boxInputSearchNewUi ? '300px' : '328px')} !important;
  }
  @media ${DEVICES.mobileS} {
    width: ${(props) => (props.boxInputSearchNewUi ? '250px' : '328px')} !important;
  }
`;
const MobileSearch = styled(BorderedSearch)`
  border: none;
  margin: unset;
  > input {
    min-height: 50px;
  }
  @media only screen and (max-width: 1080px) {
    width: 100%;
    padding: 9% 0 5% 0;
  }
`;
const DropdownBox = styled.div`
  border-radius: 3px;
  box-shadow: 2px 4px 0 0 rgba(0, 0, 0, 0.07);
  border: solid 1px ${COLORS.lightestGrey};
  background-color: ${COLORS.white};
  position: absolute;
  top: 50px;
  display: ${(p) => (p.stateName === 'hidden' ? `none` : 'block')};
  z-index: 1000;
  min-width: 100%;
  overflow-y: auto;
  @media screen and (min-width: 600px) {
    overflow-y: auto;
    max-height: 200px;
  }
  ::-webkit-scrollbar-track {
    background-color: transparent;
    -webkit-box-shadow: none;
    border-radius: 0px;
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 20px;
    height: 50px;
    border: 2px solid;
    border-color: transparent;
    background-clip: padding-box;
    -webkit-border-radius: 20px;
    box-shadow: none;
    -webkit-box-shadow: none;
    background-color: ${COLORS.borderGrey};
  }
  .suggestion {
    object-fit: contain;
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    padding: 10px;
    border: none;
    P {
      color: #000000;
      align-self: center;
      border: none !important;
    }
    img {
      margin: 0 15px;
      align-self: center;
    }
  }
`;

const SearchContainer = styled.div`
  display: flex;
  margin-top: 10px;
  flex-direction: column;
  max-height: 86px;

  .address-tooltipField {
    display: flex;
    .toolTip_Content {
      font-family: ${FONT_FAMILY.hellix.regular};
      font-size: 12px;
      font-weight: normal;
      color: ${COLORS.textLightGrey};
      letter-spacing: normal;
    }
    .toolTip {
      margin-top: 10px;
      margin-left: 10px;
      cursor: pointer;
      @media only screen and (max-width: 1080px) {
        display: none;
      }
    }
  }
  @media only screen and (max-width: 1080px) {
    align-items: ${(p) => (p.boxInputSearchNewUi ? 'left' : 'center')};
  }
  > p {
    object-fit: contain;
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${(p) => (p.disabled ? '#96a4b9' : `#091fa0`)};
    margin-left: 11px;
    cursor: ${(p) => (p.disabled ? 'not-allowed' : 'pointer')};
  }
`;
const MobileSearchContainer = styled(SearchContainer)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  max-height: 100%;
  height: 100%;
  background-color: #ffff;
  z-index: 999999999;
  background-color: #eff2f7;
`;

function SearchInput({
  state,
  className,
  placeholder,
  onSearchChange,
  disabled,
  toggleSuggestion,
  renderIcon,
  renderSuggestions,
  newSearchUi = false,
  iconPlacement = 'left'
}) {
  return (
    <div className={joinClassNames('search-wrapper', className, !disabled && 'disabled')}>
      {newSearchUi ? (
        <>
          <div
            className={`${iconPlacement === 'left' ? 'input-wrapper-left' : 'input-wrapper-right'}`}
          >
            {iconPlacement === 'left' && renderIcon()}
            <input
              type="search"
              className="search-new"
              value={state.search}
              placeholder={placeholder}
              onChange={onSearchChange}
              disabled={disabled}
              onFocus={toggleSuggestion(true)}
              onBlur={toggleSuggestion(false)}
            />
            {iconPlacement === 'right' && renderIcon()}
          </div>
          {renderSuggestions()}
        </>
      ) : (
        <>
          <input
            type="search"
            className="search"
            value={state.search}
            placeholder={placeholder}
            onChange={onSearchChange}
            disabled={disabled}
            onFocus={toggleSuggestion(true)}
            onBlur={toggleSuggestion(false)}
          />
          {renderIcon()}
          {renderSuggestions()}
        </>
      )}
    </div>
  );
}

SearchInput.propTypes = {
  state: PropTypes.any,
  className: PropTypes.any,
  placeholder: PropTypes.any,
  onSearchChange: PropTypes.any,
  disabled: PropTypes.any,
  toggleSuggestion: PropTypes.any,
  renderIcon: PropTypes.any,
  renderSuggestions: PropTypes.any,
  iconPlacement: PropTypes.string,
  newSearchUi: PropTypes.bool,
  beneAddressFlow: PropTypes.bool
};

function BoxInput({
  countryCode,
  showFields,
  state,
  placeholder,
  onSearchChange,
  disabled,
  toggleSuggestion,
  renderIcon,
  renderSuggestions,
  toggleShowfields,
  boxInputSearchNewUi,
  beneAddressFlow
}) {
  const { width } = useDeviceWidth();
  const isMobile = width < 600 ? true : false;
  const [showMobileSearch, setShowMobileSearch] = React.useState(false);
  const searchInputRef = React.useRef();
  const [hideLink, setHideLink] = React.useState(false);

  useEffect(() => {
    setHideLink(false);
  }, [countryCode]);
  const onFocus = () => {
    if (isMobile) {
      setShowMobileSearch(true);
      window.scrollTo(0, 0);
      toggleSuggestion(true)();
    } else {
      toggleSuggestion(true)();
    }
  };
  const onSearchChangeWrapper = (e) => {
    if (e.target.value) {
      setHideLink(true);
    }
    if (!e.target.value) {
      setHideLink(false);
    }
    onSearchChange(e);
  };

  if (boxInputSearchNewUi) {
    return (
      <SearchContainer
        disabled={state.search.length === 0 ? false : true}
        boxInputSearchNewUi={boxInputSearchNewUi}
      >
        <div className="address-tooltipField">
          <BorderedSearch boxInputSearchNewUi={boxInputSearchNewUi}>
            <Img src={SEARCH_ICON} alt="search-icon" className="boxInputSearchIcon" />
            <input
              type="search"
              className="search"
              value={state.search}
              placeholder={placeholder}
              onChange={onSearchChangeWrapper}
              disabled={disabled}
              onFocus={onFocus}
              onBlur={toggleSuggestion(false)}
            />
            {renderIcon(state.search, setHideLink)}
            {renderSuggestions()}
          </BorderedSearch>
        </div>
        {!beneAddressFlow && !hideLink && (
          <ManualAddressField>
            <CommonButton
              type="link"
              onClick={() =>
                showFields
                  ? !disabled && toggleShowfields(false)
                  : !disabled && toggleShowfields(true)
              }
              text="Enter address manually"
            />
          </ManualAddressField>
        )}
      </SearchContainer>
    );
  }

  return !showMobileSearch ? (
    <SearchContainer disabled={state.search.length === 0 ? false : true}>
      <div className="address-tooltipField">
        <BorderedSearch>
          <Img src={SEARCH_SMALL_ICON} alt="small-search" />
          <input
            type="search"
            className="search"
            value={state.search}
            placeholder={placeholder}
            onChange={onSearchChangeWrapper}
            disabled={disabled}
            onFocus={onFocus}
            onBlur={toggleSuggestion(false)}
          />
          {renderIcon(state.search, setHideLink)}
          {renderSuggestions()}
        </BorderedSearch>
        {beneAddressFlow ? null : (
          <div className="toolTip">
            <Popup
              position="right center"
              content={
                <div
                  style={{
                    fontFamily: FONT_FAMILY.hellix.regular,
                    fontSize: '12px',
                    fontWeight: 'normal',
                    color: COLORS.textLightGrey,
                    letterSpacing: '1',
                    lineHeight: '1.7'
                  }}
                >
                  {
                    'Address search bar will define your postal code as per your search for location of resident.'
                  }
                </div>
              }
              trigger={
                <img src={INFO_GREY_ICON} alt="address tooltip" width="20px" height="20px" />
              }
            />
          </div>
        )}
      </div>
      {!beneAddressFlow && !hideLink && (
        <MediaLink showFields={showFields}>
          <img src={ACC_ICON} alt="show" height="6px" width="6px" />
          <CommonButton
            text="Enter address manually"
            countryCode={countryCode}
            type="link"
            width={200}
            onClick={() =>
              showFields
                ? !disabled && toggleShowfields(false)
                : !disabled && toggleShowfields(true)
            }
          >
            Enter address manually
          </CommonButton>
        </MediaLink>
      )}
    </SearchContainer>
  ) : (
    <MobileSearchContainer disabled={state.search.length === 0 ? false : true}>
      <MobileSearch>
        <ImgRotate
          src={DROPDOWN_LIGHT_ICON}
          alt="small-search"
          onClick={() => {
            setShowMobileSearch(false);
          }}
        />
        <input
          ref={searchInputRef}
          type="text"
          className="search"
          value={state.search}
          placeholder={placeholder}
          onChange={onSearchChange}
          disabled={disabled}
          onFocus={onFocus}
          onBlur={toggleSuggestion(false)}
        />
        {renderIcon(state.search)}
        {renderSuggestions(setShowMobileSearch)}
      </MobileSearch>
    </MobileSearchContainer>
  );
}

BoxInput.propTypes = {
  state: PropTypes.any,
  className: PropTypes.any,
  placeholder: PropTypes.any,
  onSearchChange: PropTypes.any,
  disabled: PropTypes.any,
  toggleSuggestion: PropTypes.any,
  renderIcon: PropTypes.any,
  renderSuggestions: PropTypes.any,
  showFields: PropTypes.any,
  toggleShowfields: PropTypes.any,
  countryCode: PropTypes.string,
  boxInputSearchNewUi: PropTypes.bool,
  beneAddressFlow: PropTypes.bool
};

function Search(props) {
  const [state, setState] = useReducer((state, action) => ({ ...state, ...action }), {
    search: '',
    focus: false,
    suggestions: []
  });

  useEffect(() => {
    let { setSearchValueProvider, onSearchChange } = props;
    setSearchValueProvider &&
      setSearchValueProvider((value) => {
        setState({ search: value });
      });
    //buggy code need to have current value of search use useRef and useEffects
    onSearchChange && onSearchChange(state.search, 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Clear search box if country changes
  useEffect(() => {
    setState({ search: '' });
  }, [props.countryCode]);

  let disableBlur = false;

  function renderIcon() {
    let { search } = state,
      { onSearchChange, loading, toggleShowFields } = props;
    if (newSearchUi) {
      return (
        <>
          <img className="search-icon" alt="search" src={SEARCH_ICON} />
          {renderCloseLoading(search, null)}
        </>
      );
    } else {
      return loading ? (
        <div className="search-icon loading">&nbsp;</div>
      ) : (
        <img
          className="search-icon"
          alt="search"
          src={search ? CLOSE : SEARCH_ICON}
          onClick={
            search
              ? () => {
                  toggleShowFields();
                  setState({ search: '' }, () => {
                    onSearchChange && onSearchChange('', 1);
                    debounce(DEBOUNCE_PERIOD, props.setSearchText(state.search));
                    props.setSearchText(state.search);
                  });
                }
              : null
          }
        />
      );
    }
  }
  function renderCloseLoading(value, setHideLink) {
    let { search } = state,
      { onSearchChange, loading, toggleShowFields } = props;
    return (
      <Container>
        {loading ? (
          <CircularProgress size={20} thickness={2.6} style={{ color: '#48F9FE' }} />
        ) : (
          <Link
            onClick={
              search
                ? () => {
                    toggleShowFields();
                    setState({ search: '' }, () => {
                      onSearchChange && onSearchChange('', 1);

                      debounce(DEBOUNCE_PERIOD, props.setSearchText(state.search));
                      props.setSearchText(state.search);
                    });
                    setHideLink && setHideLink(false);
                  }
                : null
            }
          >
            {value && `Clear`}
          </Link>
        )}
      </Container>
    );
  }

  function renderSuggestions() {
    let { suggestions = [], renderSuggestion, suggestionsClassName, keepOpen } = props;
    let { focus, search } = state;
    let stateName =
      renderSuggestion && suggestions.length && (keepOpen || focus) && search
        ? 'visible'
        : 'hidden';
    return (
      <div
        className={joinClassNames('suggestion-wrapper', suggestionsClassName, stateName)}
        onClick={onSuggestionSelect}
        onScroll={onSuggestionScroll}
        onMouseEnter={() => (disableBlur = true)}
        onMouseLeave={() => (disableBlur = false)}
      >
        {renderSuggestion ? suggestions.map(renderSuggestion) : null}
      </div>
    );
  }
  function renderSuggestionsNew(closeDropdown) {
    let { suggestions = [], renderSuggestion, keepOpen } = props;
    let { focus, search } = state;
    let stateName =
      renderSuggestion && suggestions.length && (keepOpen || focus) && search
        ? 'visible'
        : 'hidden';
    return (
      <DropdownBox
        id="dropdown-suggestion"
        stateName={stateName}
        onClick={(e) => {
          if (closeDropdown) {
            window.scrollTo(0, document.body.scrollHeight);
            closeDropdown(false);
          }
          onSuggestionSelect(e, true);
        }}
        onScroll={onSuggestionScroll}
        onMouseEnter={() => (disableBlur = true)}
        onMouseLeave={() => (disableBlur = false)}
      >
        {renderSuggestion
          ? suggestions.map(({ key, title }) => (
              <div className="suggestion" key={key}>
                <img src={LOCATION_PIN_ICON} alt="location" />
                <p>{title.length > 63 ? `${title.substring(0, 63)}...` : title}</p>
              </div>
            ))
          : null}
      </DropdownBox>
    );
  }

  const onSearchChange = async ({ target: { value } }) => {
    let { onSearchChange, page, normalization } = props,
      { search: prev } = state,
      search = normalization ? normalization(value, prev) : value;
    await setState({ search });
    props.setSearchText(search);
    onSearchChange && onSearchChange(search, page, true);
  };

  function toggleSuggestion(focus) {
    return () => {
      if (!focus) {
        let { onBlur } = props;
        onBlur && onBlur();
        if (disableBlur) return;
      }
      setState({ focus });
    };
  }

  function onSuggestionSelect(e, newFlow = false) {
    let { target: suggestion } = e,
      index = newFlow
        ? Array.from(suggestion.parentNode.parentNode.children).indexOf(suggestion.parentNode)
        : Array.from(suggestion.parentNode.children).indexOf(suggestion);
    if (index < 0) return;
    let selected = props.suggestions[index],
      { onSuggestionSelect, page } = props;
    setState({ focus: false });
    onSuggestionSelect && onSuggestionSelect({ ...selected, search: state.search, page });
  }

  function onSuggestionScroll({ target }) {
    let { scrollHeight, clientHeight, scrollTop } = target,
      { totalPages, page, onSearchChange } = props;
    let scrollProgress = scrollTop / (scrollHeight - clientHeight);

    scrollProgress > 0.8 &&
      scrollProgress < 0.8 &&
      page < totalPages &&
      onSearchChange &&
      onSearchChange(state.search, page + 1, false);
  }
  let { placeholder, disabled, className, newSearchUi, iconPlacement, beneAddressFlow } = props;

  const childProps = {
    state,
    className,
    placeholder,
    onSearchChange,
    disabled,
    toggleSuggestion,
    newSearchUi,
    iconPlacement
  };
  const feat = useToggleFeat();
  // todo should come from supper parent and should be passed from super class
  return feat.toggleFeature ? (
    <BoxInput
      showFields={props.showFields}
      toggleShowfields={props.toggleShowFields}
      {...childProps}
      renderSuggestions={renderSuggestionsNew}
      renderIcon={renderCloseLoading}
      countryCode={props.countryCode}
      boxInputSearchNewUi={props.boxInputSearchNewUi}
      beneAddressFlow={beneAddressFlow}
    />
  ) : (
    <SearchInput
      {...childProps}
      renderSuggestions={newSearchUi ? renderSuggestionsNew : renderSuggestions}
      renderIcon={renderIcon}
    />
  );
}

Search.propTypes = {
  onSearchChange: PropTypes.func,
  onSuggestionSelect: PropTypes.func,
  renderSuggestion: PropTypes.func,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  suggestionsClassName: PropTypes.string,
  suggestions: PropTypes.array,
  setSearchValueProvider: PropTypes.func,
  totalPages: PropTypes.number,
  page: PropTypes.number,
  loading: PropTypes.bool,
  onBlur: PropTypes.func,
  normalization: PropTypes.func,
  keepOpen: PropTypes.bool,
  setSearchText: PropTypes.any,
  countryCode: PropTypes.string,
  toggleShowFields: PropTypes.func,
  toggleNewFeature: PropTypes.func,
  showFields: PropTypes.any,
  newSearchUi: PropTypes.bool,
  iconPlacement: PropTypes.string,
  boxInputSearchNewUi: PropTypes.bool,
  beneAddressFlow: PropTypes.bool
};

Search.defaultProps = {
  disabled: false,
  totalPages: 1,
  page: 0,
  countryCode: ''
};

export default connect(null, { setSearchText })(Search);
